import { render } from "./industry-allocation.vue?vue&type=template&id=84ff06d6&scoped=true"
import script from "./industry-allocation.vue?vue&type=script&lang=js"
export * from "./industry-allocation.vue?vue&type=script&lang=js"

import "./industry-allocation.vue?vue&type=style&index=0&id=84ff06d6&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ff06d6"]])

export default __exports__